export default __webpack_public_path__ + "static/media/browser_buttons.e8852eb9.svg";